import React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PlayIcon from '@material-ui/icons/PlayArrow';

import { TrashIcon, /*EditIcon,*/ BlueCloseIcon } from '../../../images/icons/WrapSvg';

class Index extends React.Component {
    render() {
        const { anchorEl, producciondetenida, abierto, handleClose, intl } = this.props;
        return (
            <Menu
                id="recipe-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem className={'popup_menuItem'} onClick={() => handleClose('waste')}>
                    <ListItemIcon className={'popup_icon'}>
                        <TrashIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText
                        classes={{ primary: 'popup_primary c_bluish barlow_semibold_label' }}
                        inset
                        primary={intl.formatMessage({ id: 'xhef_popup_waste' })}
                    />
                </MenuItem>
                {/*
                <MenuItem className={'popup_menuItem'} onClick={() => handleClose('projection')}>
                    <ListItemIcon className={'popup_icon'}>
                        <EditIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText
                        classes={{ primary: 'popup_primary c_bluish barlow_semibold_label' }}
                        inset
                        primary={intl.formatMessage({ id: 'xhef_popup_projection' })}
                    />
                </MenuItem>
                */}
                {(abierto && producciondetenida) &&
                    <MenuItem
                        className={'popup_menuItem'}
                        onClick={() => handleClose('start_production')}
                    >
                        <ListItemIcon className={'popup_icon'}>
                            <PlayIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: 'popup_primary c_bluish barlow_semibold_label' }}
                            inset
                            primary={intl.formatMessage({ id: 'xhef_popup_production_start' })}
                        />
                    </MenuItem>
                }
                {(abierto && !producciondetenida) &&
                    <MenuItem
                        className={'popup_menuItem'}
                        onClick={() => handleClose('production')}
                    >
                        <ListItemIcon className={'popup_icon'}>
                            <BlueCloseIcon color="secondary" />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: 'popup_primary c_lipstick barlow_semibold_label' }}
                            inset
                            primary={intl.formatMessage({ id: 'xhef_popup_production' })}
                        />
                    </MenuItem>
                }
            </Menu>
        );
    }
}

Index.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Index);



// WEBPACK FOOTER //
// ./src/components/complex/xhef/Popup.js